import React, { useState } from 'react'
import getRespiratoryRateChartOptions from '../../../utils/charts/baseRespiratoryRateChart'
import ChartModule from './ChartModule'
import TabPanel from '../../layout/TabPanel'
import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material'
import { a11yProps } from '../../../constants/constants'
import { type IChartOptionsParams } from '../../../interfaces/chart.interface'
import EmptyTable from '../Tables/EmptyTable'

export default function RespiratoryRateChart (props: IChartOptionsParams): JSX.Element {
  const [selectedRespiratoryRateTab, setSelectedRespiratoryRateTab] = useState(0)

  const renderChartPanel = (): JSX.Element => {
    return (
      <Card className='chart-card' id='respiratory_rate-card'>
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'end', m: 0 }}>
            <Typography variant='h6' color='#7f7f7f'> Resting Respiratory Rate </Typography>
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={selectedRespiratoryRateTab}
              onChange={(_e, val) => { setSelectedRespiratoryRateTab(val) }}
              aria-label='chart tabs'
            >
              <Tab data-testid='respiratory_rate__charts-tab' label='Graph' {...a11yProps('respiratoryrate-metric__tab', 0)} />
              <Tab data-testid='respiratory_rate__table-tab' label='Table' {...a11yProps('respiratoryrate-metric__tab', 1)} />
            </Tabs>
          </Box>
          <TabPanel value={selectedRespiratoryRateTab} index={0} noPadding>
            <ChartModule
              hideHeader
              hideBorder
              showChartActions
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
              metricType='respiratory_rate'
              getChartOptions={getRespiratoryRateChartOptions}
              showMemberAlerts={props.showMemberAlerts}
              handleAlertClick={props.handleAlertClick} // eslint-disable-line react/jsx-handler-names
            />
          </TabPanel>
          <TabPanel value={selectedRespiratoryRateTab} index={1} noPadding>
            {/* TODO Replace with real table */}
            <EmptyTable hideHeader hideBorder dashboardViewStore={props.dashboardViewStore} memberObj={props.memberObj}></EmptyTable>
          </TabPanel>
        </CardContent>
      </Card>
    )
  }

  return renderChartPanel()
}
